import * as React from "react";
const LockFillSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M8,6 C8,4.897 8.897,4 10,4 C11.103,4 12,4.897 12,6 L12,8 L8,8 L8,6 Z M14.5,8 L13,8 L13,6 C13,4.346 11.654,3 10,3 C8.346,3 7,4.346 7,6 L7,8 L5.5,8 C4.673,8 4,8.672 4,9.5 L4,15.5 C4,16.327 4.673,17 5.5,17 L14.5,17 C15.327,17 16,16.327 16,15.5 L16,9.5 C16,8.672 15.327,8 14.5,8 L14.5,8 Z" }));
LockFillSmall.displayName = "LockFillSmall";
var LockFillSmall_default = LockFillSmall;
export {
  LockFillSmall_default as default
};
